// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swiper-pagination {\n  width: 100%;\n  bottom: -40px !important;\n}\n.swiper-pagination .swiper-pagination-bullet {\n  margin-right: 10px;\n  width: 16px;\n  height: 16px;\n  background: transparent;\n  border: 2px solid #006BCF;\n}\n.swiper-pagination .swiper-pagination-bullet-active {\n  background: #006BCF;\n  width: 50px;\n  border-radius: 50px;\n}\n.swiper-pagination.swiper-pagination-pc {\n  position: relative;\n}", ""]);
// Exports
module.exports = exports;
